import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from '@mui/system';
import { useMemo } from 'react';
import { listStyle, stackStyle } from './styles';
const stackText = (text, containerProps = {}) => {
    return (_jsx(Box, { ...containerProps, sx: stackStyle, children: text.map((txt) => (_jsx("span", { children: txt }))) }));
};
/**
 * LabelledListItem component
 * @param {IListItem} props - The props of the component
 * @param {string} props.id - The unique ID for screen reader accessibility
 * @param {string | string[]} props.label - The label of the item
 * @param {string | string[]} props.text - The text of the item
 * @param {boolean} props.isBold - The boolean to determine if the text is bold 800 weight
 * @param {boolean} props.isSemiBold - The boolean to determine if the text is semi-bold 700 weight
 * @param {string} props.labelClass - The class of the label
 * @returns {React.FC<IListItem>} The LabelledListItem component
 */
export const LabelledListItem = ({ id, label, text, isBold, isSemiBold, labelClass = '', }) => {
    const textContent = useMemo(() => {
        // Stack contents if array
        if (Array.isArray(text))
            return stackText(text, { 'aria-labelledby': id });
        return _jsx("span", { "aria-labelledby": id, children: text });
    }, [text]);
    const labelContent = useMemo(() => {
        // Stack contents if array
        if (Array.isArray(label))
            return stackText(label);
        return _jsx("span", { children: label });
    }, [text]);
    const hasBold = isBold || isSemiBold;
    return (_jsxs("li", { id: `${id}-wrapper`, children: [hasBold ? _jsx("b", { className: isSemiBold ? 'semi' : '', children: textContent }) : textContent, _jsx("label", { id: id, className: labelClass, children: labelContent })] }));
};
/**
 * LabelledList component
 * @param {ILabelledListProps} props - The props of the component
 * @param {IListItem[]} props.list - The list of items
 * @param {boolean} props.isMobile - The boolean to determine if the device is mobile
 * @returns {React.FC<ILabelledListProps>} The LabelledList component
 */
export const LabelledList = ({ list, className }) => {
    return (_jsx(Box, { className: className, sx: listStyle, children: _jsx("ul", { className: 'labelled-list', children: list.map((item) => (_jsx(LabelledListItem, { ...item }, item.id))) }) }));
};
